module.exports = __webpack_public_path__ + "img/xzl.1398fea6.png";